import { FoodDrumstickOutlineIcon } from './FoodDrumstickOutlineIcon';

/**
 * author: Michael Irigoyen
 * id D60C4F90-EE53-4A92-84F7-076DAC23FD31
 * name food-drumstick-outline
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/food-drumstick-outline.svg
 * tags
 * - Food / Drink 
 */
export const TurkeyLegOutlineIcon = FoodDrumstickOutlineIcon;
export default TurkeyLegOutlineIcon